module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "mb-10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-4": ""
    }
  }, _vm._l((_vm.filteredOrders), function(order, i) {
    return _c('order', {
      key: i,
      attrs: {
        "list": "",
        "value": order
      },
      on: {
        "details": function($event) {
          return _vm.details($event)
        }
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "v-subheader theme--light"
  }, [_vm._v("itens por página")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "value": _vm.itemsPerPage,
      "bottom": "",
      "required": "",
      "items": _vm.comboList
    },
    on: {
      "change": _vm.refreshList
    },
    model: {
      value: (_vm.ipp),
      callback: function($$v) {
        _vm.ipp = $$v
      },
      expression: "ipp"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "pt-3 pr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.pagingText))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage > 1),
      expression: "currentPage > 1"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage < _vm.totalPages),
      expression: "currentPage < totalPages"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3cac780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/pedidos/OrderList/index.vue
// module id = 432
// module chunks = 18 19 20 21